import React from "react";
import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="glass rounded-2xl p-8 max-w-md w-full text-center">
        <div className="text-6xl mb-3">🙈</div>
        <div className="text-xs uppercase tracking-[0.3em] text-white/50">Cancelled</div>
        <div className="font-display text-2xl mt-2">Payment cancelled</div>
        <p className="text-white/60 mt-3 text-sm">No charges made. Take your time.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <button onClick={() => nav("/store")} className="px-5 py-2.5 rounded-full bg-[color:var(--uno-yellow)] text-black font-semibold">Back to store</button>
          <button onClick={() => nav("/lobby")} className="px-5 py-2.5 rounded-full bg-white/10 hover:bg-white/20 font-semibold">Lobby</button>
        </div>
      </div>
    </div>
  );
}
